import React, { useEffect, useRef, useState } from "react";
import { getBaseUrl } from "../../../../../Redux/Config/AppConfig";
import { useDispatch } from "react-redux";
import {
  POST_RESTAURANT_SUB_CATEGORY_REQUEST,
  PUT_RESTAURANT_SUB_CATEGORY_REQUEST,
} from "../../../../../Utils/Constant";

const AddRestaurantSubCategory = ({
  selectedCategory,
  setSelectedCategory,
  categoryId,
}) => {
  const BaseUrl = getBaseUrl();
  const closeBtnRef = useRef(null);
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    price: "",
    image: null,
  });
  const [initialData, setInitialData] = useState(null); // to restore on clear
  const [errors, setErrors] = useState({});
  const [previewUrl, setPreviewUrl] = useState(null);

console.log("formData",formData)
  // Prefill data when editing
  useEffect(() => {
    if (selectedCategory) {
      const data = {
        name: selectedCategory?.name || "",
        description: selectedCategory?.description || "",
        price: selectedCategory?.price?.toString() || "",
        image: null,
      };
      setFormData(data);
      setInitialData(data); // store original edit values
      setPreviewUrl(selectedCategory?.image || null);
    } else {
      clearForm();
    }
    setErrors({});
  }, [selectedCategory]);

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Dish name is required.";
    if (!formData.description.trim())
      newErrors.description = "Description is required.";
    if (!formData.price.trim()) newErrors.price = "Price is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, image: file }));
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const clearForm = () => {
    setFormData({ name: "", description: "", price: "", image: null });
    setPreviewUrl(null);
    setErrors({});
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; 
    }
  };

  const handleClear = () => {
    if (selectedCategory && initialData) {
      setFormData({ ...initialData, image: null });
      setPreviewUrl(selectedCategory?.image || null);
    } else {
      clearForm();
    }
  };

  const handleSubmit = () => {
    if (!validate()) return;

    const form = new FormData();
    form.append("name", formData?.name);
    form.append("description", formData?.description);
    form.append("price", formData?.price);
    form.append("category_id", categoryId);
    if (formData?.image instanceof File) {
      form.append("image", formData?.image);
      const hotel_id=localStorage.getItem('hotel_id')
      // form.append("hotel_id", hotel_id);
    }

    if (selectedCategory) {
      dispatch({
        type: PUT_RESTAURANT_SUB_CATEGORY_REQUEST,
        payload: { id: selectedCategory?.id, body: form },
      });
    } else {
      dispatch({
        type: POST_RESTAURANT_SUB_CATEGORY_REQUEST,
        payload: { body:  form  },
      });
    }

    clearForm();
    setSelectedCategory(null); // optional: reset edit mode
    closeBtnRef.current?.click();
  };

  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex="-1"
      id="add-sub-category"
      aria-labelledby="add-sub-category"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">
          {selectedCategory ? "Edit Dish" : "Add Dish"}
        </h5>
        <button
          ref={closeBtnRef}
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={() => setErrors({})}
        ></button>
      </div>
      <div className="offcanvas-body">
        {/* Dish Name */}
        <div className="form-group mb-3">
          <label className="form-label text-muted">
            Dish Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            name="name"
            className={`form-control ${errors.name ? "is-invalid" : ""}`}
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter name"
          />
          {errors.name && <div className="invalid-feedback">{errors.name}</div>}
        </div>

        {/* Description */}
        <div className="form-group mb-3">
          <label className="form-label text-muted">
            Description <span className="text-danger">*</span>
          </label>
          <textarea
            name="description"
            className={`form-control ${errors.description ? "is-invalid" : ""}`}
            value={formData.description}
            onChange={handleChange}
            placeholder="Enter description"
          ></textarea>
          {errors.description && (
            <div className="invalid-feedback">{errors.description}</div>
          )}
        </div>

        {/* Price */}
        <div className="form-group mb-3">
          <label className="form-label text-muted">
            Price (₹) <span className="text-danger">*</span>
          </label>
          <input
            type="number"
            name="price"
            className={`form-control ${errors.price ? "is-invalid" : ""}`}
            value={formData.price}
            onChange={handleChange}
            placeholder="Enter price"
          />
          {errors.price && (
            <div className="invalid-feedback">{errors.price}</div>
          )}
        </div>

        {/* Dish Image Upload */}
        <div className="form-group mb-3">
          <label className="form-label text-muted">
            Dish Image <span className="text-muted">(optional)</span>
          </label>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            className="form-control"
            onChange={handleImageChange}
          />
          {console.log(typeof formData.image,"formData.image",formData.image)}
          {previewUrl && (
            <div className="mt-3">
              <img
                src={previewUrl}
                alt="Dish Preview"
                className="img-thumbnail shadow-sm"
                style={{
                  maxHeight: "180px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div className="d-flex mt-4">
          <button
            type="button"
            className="btn w-100 me-1 py-2 btn-outline-secondary"
            onClick={handleClear}
          >
            Clear
          </button>
          <button
            type="button"
            className="btn w-100 ms-1 py-2 btn-dark"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddRestaurantSubCategory;
